import { Alert, Button, Center, Stack } from "@biblioteksentralen/react";
import { EventFacetName } from "@libry-content/common";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { VisuallyHiddenResults } from "../VisuallyHiddenResults";
import { EventFacetButtons } from "./EventFacetButtons";
import { EventsListContextProvider, EventsListContextProviderProps, useEventsListContext } from "./EventFilterContext";
import { EventsList } from "./EventsList";

export const eventsListSelectedLibrariesFilterKey: EventFacetName = "libraries";

export const EventsWithFilters = (props: Omit<EventsListContextProviderProps, "children">) => (
  <EventsListContextProvider {...props}>
    <EventsAndFilters />
  </EventsListContextProvider>
);

function EventsAndFilters() {
  const { t } = useTranslation();
  const { loadMoreEvents, events, endOfResults, isValidating } = useEventsListContext();

  const eventsCount = events?.length ?? 0;

  return (
    <Stack>
      <EventFacetButtons />
      <VisuallyHiddenResults
        itemsLength={eventsCount}
        name={eventsCount === 1 ? t("arrangement") : t("arrangementer")}
      />
      {events?.length ? (
        <EventsList events={events} />
      ) : (
        <Alert status="info" marginY="3rem" width="max-content" paddingRight="1.5rem">
          {t("Vi har ingen planlagte arrangementer så langt frem i tid")}
        </Alert>
      )}
      {!endOfResults && (
        <Center marginY="1rem">
          <Button isLoading={isValidating} variant="secondary" onClick={loadMoreEvents}>
            {t("Vis mer")}
          </Button>
        </Center>
      )}
    </Stack>
  );
}
